export const selectBlockPatternsKey = Symbol( 'selectBlockPatternsKey' );
